/**
 * Returns the dotIndex (see <Dots>) for the current balance.
 *
 * @param state
 * @returns {number}
 */
function dotIndex(state) {
  return state.currentReads.dotIndex
}

function updateDotsStepDuration(state) {
  return state.currentReads.updateDotsStepDuration
}

function currentReadIsConsumption(state) {
  // We can assume that only toGrid or fromGrid is > 0.
  return state.currentReads.fromGrid > 0
}

function currentRead(state) {
  if (state.currentReads.toGrid > 0) {
    return state.currentReads.toGrid
  } else {
    return state.currentReads.fromGrid
  }
}

function currentBalance(state) {
  return state.currentReads.balance
}

function currentReads(state) {
  return state.currentReads
}

function consumingFromCommunity(state) {
  return state.currentReads.fromCommunity
}

function consumingFromSupplier(state) {
  return state.currentReads.fromSupplier
}

function dotCoordinates(state) {
  return state.currentReads.dotCoordinates
}

function wattageTweenDuration(state) {
  return state.global.wattageTweenDuration
}

export default {
  dotIndex,
  dotCoordinates,
  updateDotsStepDuration,
  currentRead,
  currentReadIsConsumption,
  currentBalance,
  consumingFromCommunity,
  consumingFromSupplier,
  wattageTweenDuration,
  currentReads,
}
